var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sdr-box contact-box", staticStyle: { padding: "10px" } },
      [
        _c("figure", [
          _c("img", {
            staticStyle: { "border-radius": "3%" },
            attrs: {
              src: "/res/images/banner-sdr/banner5.png",
              alt: "",
              width: "100%",
            },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }